import axios from "axios";

const baseURL = axios.create({
  baseURL: "https://osramarket.up.railway.app/api",
});

const loggedUser=JSON.parse(localStorage.getItem('user')); 
let token
if(loggedUser?.token) {
  token = loggedUser?.token
}


baseURL.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);


export const config = {
  headers: {
    ...(token
      ? { token: `Bearer ${token}` }
      : { is_admin: true }),
  },
};

export default baseURL;
